import {
  forgotPassAxios,
  logOutAxios,
  loginAxios,
  registerAxios,
  resetPassAxios,
} from "../instance";
import {
  ILoginFormData,
  IRegisterFormData,
  IResetPassData,
  IToken,
} from "@/hooks/types";

export const handleGetToken = async (
  loginData: ILoginFormData
): Promise<IToken> => {
  const { data } = await loginAxios.post("", loginData);

  return data;
};
export const handleRegister = async (registerData: IRegisterFormData) => {
  const { data } = await registerAxios.post("", registerData);

  return data;
};
export const handleLogOut = async (token: string): Promise<any> => {
  const { data } = await logOutAxios.delete("", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return data;
};
export const handleForgotEmail = async (email: string): Promise<any> => {
  const { data } = await forgotPassAxios.post("", { email });

  return data;
};
export const handleResetPass = async (
  resetPassData: IResetPassData
): Promise<any> => {
  const { data } = await resetPassAxios.post("", resetPassData);

  return data;
};
